export const SITE_FLAGS = {
    froshWeek: false
}